import { connect } from 'react-redux';
import { showPaymentModal } from 'project/ducks/project_1_1';
import Pay1to1 from 'project/components/brief/pay_1_1';

const mapStateToProps = ({ project }) => {
  const { showingPaymentModal } = project.projectPage.project1To1;
  return {
    showingPaymentModal
  }
}

export default connect(mapStateToProps, {
  showPaymentModal,
})(Pay1to1);



// WEBPACK FOOTER //
// ./project/containers/pay_1_1.jsx